"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable class-methods-use-this */
const three_1 = require("three");
// eslint-disable-next-line import/no-cycle
const utils_1 = require("~/utils/utils");
const Cad3d_scss_1 = __importDefault(require("../Cad3d.scss"));
// eslint-disable-next-line import/no-cycle
const utils_2 = require("../utils");
class Leader {
    constructor(viewer, lineMaterial, prefix) {
        this.viewer = viewer;
        this.lineMaterial = lineMaterial;
        this.prefix = prefix;
        this.label = this.createLabel();
        this.yCoordGap = -37;
    }
    getLine() {
        return this.line;
    }
    setLabelVisible(visible) {
        this.label.style.display = visible ? 'block' : 'none';
    }
    getLabelPosition() {
        return { left: this.label.style.left, top: this.label.style.top };
    }
    draw(startPoint, endPoint) {
        this.drawLine(startPoint, endPoint);
        this.drawLabel(startPoint, endPoint);
    }
    drawOnlyLine(startPoint, endPoint) {
        this.drawLine(startPoint, endPoint);
    }
    clear() {
        this.viewer.getScene().remove(this.line);
        if (this.label.isConnected) {
            this.label.remove();
        }
    }
    updateLabelPosition() {
        if (!this.label || !this.line) {
            return;
        }
        const labelPosition = utils_2.Utils.objectPositionToScreenPosition(this.line, this.viewer.getCamera(), true);
        if (!labelPosition) {
            return;
        }
        this.label.style.left = `${labelPosition.x}px`;
        this.label.style.top = `${labelPosition.y + this.yCoordGap}px`;
    }
    createLabel() {
        const label = document.createElement('div');
        label.classList.add(Cad3d_scss_1.default.label);
        return label;
    }
    createLine(startPoint, endPoint) {
        const line = new three_1.Line(new three_1.BufferGeometry().setFromPoints([startPoint, endPoint]), this.lineMaterial);
        const group = new three_1.Group();
        group.add(line);
        return group;
    }
    drawLine(startPoint, endPoint) {
        const scene = this.viewer.getScene();
        if (this.line) {
            scene.remove(this.line);
        }
        this.line = this.createLine(startPoint, endPoint);
        scene.add(this.line);
    }
    setLabelText(text, prefix) {
        this.label.innerText = `${prefix} ${text}`;
    }
    drawLabel(startPoint, endPoint, appendZeroes = false) {
        const distance = startPoint.distanceTo(endPoint);
        const distanceText = this.viewer.isImperialMeasurementUsed
            ? (0, utils_1.getLabelInInch)(distance, appendZeroes)
            : (0, utils_1.getLabelInMM)(distance, appendZeroes);
        this.setLabelText(distanceText, this.prefix);
        if (!this.label.isConnected) {
            this.addLabel(this.label);
        }
        const labelPosition = this.pointBetween(startPoint, endPoint);
        this.showLabelAtPoints(labelPosition);
    }
    addLabel(label) {
        const root = document.getElementById('root');
        root === null || root === void 0 ? void 0 : root.insertBefore(label, root.childNodes[0]);
    }
    getClientRectSize() {
        const { left, top, bottom, right } = this.viewer.getRenderer().domElement.getBoundingClientRect();
        const width = right - left;
        const height = bottom - top;
        return { width, height };
    }
    setLabelPosition(screenPoint) {
        const labelRect = this.label.getBoundingClientRect();
        const transformedScreenPoint = screenPoint.clone();
        const { width, height } = this.getClientRectSize();
        transformedScreenPoint.y -= labelRect.bottom - labelRect.top;
        transformedScreenPoint.clamp(new three_1.Vector3(0, 0), new three_1.Vector3(width - (labelRect.right - labelRect.left), height - (labelRect.bottom - labelRect.top)));
        this.label.style.left = `${transformedScreenPoint.x}px`;
        this.label.style.top = `${transformedScreenPoint.y}px`;
    }
    showLabelAtPoints(point) {
        this.label.style.display = 'block';
        const { width, height } = this.getClientRectSize();
        const screenPoint = point.clone();
        screenPoint.project(this.viewer.getCamera());
        screenPoint.x = ((screenPoint.x + 1) / 2) * width;
        screenPoint.y = (1 - (screenPoint.y + 1) / 2) * height;
        this.setLabelPosition(screenPoint);
    }
    pointBetween(point1, point2) {
        const midPoint = new three_1.Vector3().subVectors(point2, point1).divideScalar(2);
        midPoint.add(point1);
        return midPoint;
    }
}
exports.default = Leader;
